import script from "./empty-table-placeholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./empty-table-placeholder.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__